import React, { useEffect } from "react";
import { CreditProposal } from "../../components/templates/CreditProposal";
import { observer } from "mobx-react-lite";
import { strings } from "../../localization";
import { LINK_NOVERDE } from "../../constants";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { useNavigateCustom } from "../../hooks";

const CustomerRefusal: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const { title, description, offers, tag, titleCard, descriptionCard, buttonTextOnContinue, buttonTextOnBack } =
		strings.templates.CreditProposal;

	const onRedirect = (): void => {
		window.location.href = LINK_NOVERDE;
	};

	const onBack = (): void => {
		navigation("/", { replace: true });
	};

	useEffect(() => {
		authenticationStore.logout();
	}, []);

	return (
		<CreditProposal
			onRedirect={onRedirect}
			onBack={onBack}
			title={title}
			description={description}
			offers={offers}
			tag={tag}
			titleCard={titleCard}
			descriptionCard={descriptionCard}
			buttonTextOnContinue={buttonTextOnContinue}
			buttonTextOnBack={buttonTextOnBack}
		/>
	);
});

export default CustomerRefusal;
